import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export const AbuseSignalsTab = () => {
  const [topUsers, setTopUsers] = useState<{ user_id: string; count: number }[]>([]);
  const [topSpots, setTopSpots] = useState<{ parking_spot_id: string; count: number }[]>([]);

  useEffect(() => {
    const load = async () => {
      const { data: cancelled } = await supabase
        .from("bookings")
        .select("user_id, parking_spot_id")
        .eq("status", "cancelled")
        .limit(1000);
      const u: Record<string, number> = {};
      const s: Record<string, number> = {};
      (cancelled || []).forEach((b: any) => {
        if (b.user_id) u[b.user_id] = (u[b.user_id] || 0) + 1;
        if (b.parking_spot_id) s[b.parking_spot_id] = (s[b.parking_spot_id] || 0) + 1;
      });
      setTopUsers(Object.entries(u).map(([user_id, count]) => ({ user_id, count })).sort((a, b) => b.count - a.count).slice(0, 10));
      setTopSpots(Object.entries(s).map(([parking_spot_id, count]) => ({ parking_spot_id, count })).sort((a, b) => b.count - a.count).slice(0, 10));
    };
    load();
  }, []);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <Card>
        <CardHeader><CardTitle>Top users by cancellations</CardTitle></CardHeader>
        <CardContent>
          <Table>
            <TableHeader><TableRow><TableHead>User</TableHead><TableHead className="text-right">Cancellations</TableHead></TableRow></TableHeader>
            <TableBody>
              {topUsers.map((u) => (
                <TableRow key={u.user_id}>
                  <TableCell className="font-mono text-xs">{u.user_id.slice(0, 12)}</TableCell>
                  <TableCell className="text-right">{u.count}</TableCell>
                </TableRow>
              ))}
              {topUsers.length === 0 && <TableRow><TableCell colSpan={2} className="text-center text-muted-foreground">No data</TableCell></TableRow>}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
      <Card>
        <CardHeader><CardTitle>Top spots by cancellations</CardTitle></CardHeader>
        <CardContent>
          <Table>
            <TableHeader><TableRow><TableHead>Spot</TableHead><TableHead className="text-right">Cancellations</TableHead></TableRow></TableHeader>
            <TableBody>
              {topSpots.map((s) => (
                <TableRow key={s.parking_spot_id}>
                  <TableCell className="font-mono text-xs">{s.parking_spot_id.slice(0, 12)}</TableCell>
                  <TableCell className="text-right">{s.count}</TableCell>
                </TableRow>
              ))}
              {topSpots.length === 0 && <TableRow><TableCell colSpan={2} className="text-center text-muted-foreground">No data</TableCell></TableRow>}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
};
